module.exports = __webpack_public_path__ + "img/activities-4.e5a3f416.jpg";